module.exports = __webpack_public_path__ + "img/DSC_0047.fdad992d.jpg";